import { render, staticRenderFns } from "./PublicidadInicial.vue?vue&type=template&id=5c4c1c4b&scoped=true"
import script from "./PublicidadInicial.vue?vue&type=script&lang=js"
export * from "./PublicidadInicial.vue?vue&type=script&lang=js"
import style0 from "./PublicidadInicial.vue?vue&type=style&index=0&id=5c4c1c4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4c1c4b",
  null
  
)

export default component.exports